import { useEffect } from "react";
import { useTracker } from "../hooks/useTracker";

export default function TrackSession() {

    const { trackEvent } = useTracker();

    useEffect(() => {
        function setSessionCookie() {
            trackEvent({ event: "page_view", details: { route: window.location.pathname } });
        }
        // При первом рендере делаем запрос к серверу для установки sessionId cookie
        setSessionCookie();

        // Слушаем переходы по страницам (Gatsby route updates)
        const onRouteUpdate = () => {
            setSessionCookie();
        };

        window.addEventListener("gatsby:route-update", onRouteUpdate);

        // Чистим listener при размонтировании
        return () => {
            window.removeEventListener("gatsby:route-update", onRouteUpdate);
        };
    }, []);

    return null;
}
